import React from 'react';
import { Phone } from 'lucide-react';
import { usePhone } from '../../contexts/PhoneContext';

// Any phone number anywhere: render through this to make it dialable.
export const ClickablePhone = ({ number, display, meta, className = '', iconOnly = false }) => {
  const phone = usePhone();
  if (!number) return null;
  const label = display || number;
  if (!phone?.config?.phone_enabled) {
    return iconOnly ? null : <span className={className}>{label}</span>;
  }
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    phone?.dial(number, meta);
  };
  if (iconOnly) {
    return (
      <button type="button" onClick={onClick} title={`Call ${number}`}
        className={`inline-flex items-center justify-center w-6 h-6 rounded-full bg-teal-50 text-teal-600 hover:bg-teal-100 border border-teal-200 ${className}`}
        data-testid={`click-to-call-${number}`}>
        <Phone className="w-3 h-3" />
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} title={`Call ${number}`}
      className={`inline-flex items-center gap-1 text-teal-700 hover:text-teal-900 hover:underline font-medium ${className}`}
      data-testid={`click-to-call-${number}`}>
      <Phone className="w-3 h-3" />{label}
    </button>
  );
};
